import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface IProps {
  iconFile?: string;
  parentMenu?: string;
  currentMenu: string;
  onlyTitle?: boolean;
}

const Header: FC<IProps> = ({ iconFile, parentMenu, currentMenu, onlyTitle=false }) => {
  return (
    <>
      <Helmet><title>{currentMenu}</title></Helmet>
      {!onlyTitle &&
        <div className="comm-bx__between">
          <h3 className="sub-title">{currentMenu}</h3>
        </div>
      }
    </>
  )
}

export default Header